import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  CardMedia,
} from '@mui/material';
import { styled, ThemeProvider, createTheme } from '@mui/material/styles';
import Footer from '../navbar/Footer';
import moment from 'moment';

const bulletinsData = [
  {
    title: "Enquête Nationale Agricole du Burundi 2017-2018 | Résultats de la Campagne Agricole",
    link: "/documents/enqueteAgricoles/Campagne-ENAB-2017-2018-VF-avec-Observation-du-CT-1.pdf",
    date: "2018-12-01",
    image: 'assets/covers/cover4.PNG', 
    description: "L'Enquête Nationale Agricole 2017-2018 révèle que l'agriculture burundaise couvre 1,56 million d'ha, produisant 2,1 millions de tonnes de vivres (soit 378 jours de consommation/personne), avec un cheptel de 1,1 million de bovins et 3,2 millions de caprins.",
  },
  {
    title: "Enquête Nationale Agricole du Burundi 2016-2017 | Résultats de la Campagne Agricole",
    link: "/documents/enqueteAgricoles/Campagne-ENAB-2016-2017-VF-06-07-2018-_2_.pdf",
    date: "2018-06-01",
    image: 'assets/covers/cover4.PNG', 
    description: "L'Enquête Nationale Agricole 2016-2017 révèle : 1,74 million de ménages agricoles (78% dirigés par des hommes), cultivant 1,44 million d'ha et produisant 1,85 million de tonnes de vivres. Le cheptel compte 1 million de bovins et 3 millions de caprins, avec seulement 8,2% des ménages organisés en coopératives",
  },
  {
    title: "Enquête Nationale Agricole du Burundi 2015-2016 | Résultats de la Campagne Agricole",
    link: "/documents/enqueteAgricoles/Rapport-campagne-2015-2016-VF-Dieudonne-07-fev-2018.pdf",
    date: "2017-12-01",
    image: 'assets/covers/cover4.PNG', 
    description: "L'ENAB 2015-2016 révèle que les 1,74 millions de ménages agricoles burundais (5,2 personnes/ménage) cultivent 1,39 million d'ha, produisant 1,93 million de tonnes de vivres (352 jours de consommation/pers.). Le cheptel compte 1,08 million de bovins et 3,62 millions de caprins, mais seulement 11% des producteurs sont organisés en coopératives.",
  },
  {
    title: "Enquête Nationale Agricole du Burundi Saison 2014-2015 | Résultats de la Saison A",
    link: "/documents/enqueteAgricoles/Resultats_ENAB_2014_2015_A_8_fevrier_2016_2015_vf.site_.pdf",
    date: "2015-10-01",
    image: 'assets/covers/cover4.PNG', 
    description: "La saison agricole 2014-2015 A a enregistré une hausse de 25,5% de la production vivrière, avec des conditions climatiques favorables (sauf à Cibitoke). Les tubercules constituent 70% des revenus ruraux, soulignant leur importance cruciale dans l'économie familiale.",
  },
  {
    title: "Enquête Nationale Agricole du Burundi 2013-2014 | Résultats de la Saison A (Rapport définitif)",
    link: "/documents/enqueteAgricoles/Rapport-Definitif-ENAB-2013-2014_Saison-A-VF_28.05.2014.pdf",
    date: "2014-05-01",
    image: 'assets/covers/cover4.PNG', 
    description: "L'ENAB 2013-2014 révèle : 347 979 ha cultivés en saison A, produisant 1,28 million de tonnes de vivres. Banane à bière (75,4% des ménages) et manioc amer (76,9%) dominent, avec une densité agricole élevée (307,2 pers./km²).",
  },
  {
    title: "Enquête Nationale Agricole du Burundi 2011-2012 | Résultats de la Campagne Agricole",
    link: "/documents/enqueteAgricoles/ENAB-2011-12-Rapport-campagne-agricole.docx",
    date: "2013-04-01",
    image: 'assets/covers/cover4.PNG', 
    description: "L'Enquête Nationale Agricole 2011-2012 révèle 1,56 million de ménages agricoles (78,5% dirigés par des hommes), cultivant 1,26 million d'ha et produisant 1,41 million de tonnes de vivres. Le cheptel compte 9430 bovins et 2,49 millions de caprins, avec 24,5% des ménages organisés en coopératives.",
  },
  {
    title: "Enquête Nationale Agricole du Burundi 2012-2013 | Résultats de la Saison A (Rapport provisoire)",
    link: "/documents/enqueteAgricoles/Rapport-final-ENAB-saison-2013A.pdf",
    date: "2013-01-01",
    image: 'assets/covers/cover4.PNG', 
    description: "Enquête agricole 2012-2013 (1 280 ménages) : 419 095 ha cultivés, produisant 621 517 tonnes (399 kg/ménage). Seuls 31,4% des ménages utilisent des engrais et 13,8% sont organisés, avec une densité agricole de 305,6 pers./km².",
  },
];

function EnqueteAgricole() {
  const [visibleCount, setVisibleCount] = useState(2);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredBulletins, setFilteredBulletins] = useState(bulletinsData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);

    if (year === 'Tous') {
      setFilteredBulletins(bulletinsData);
    } else {
      const filtered = bulletinsData.filter((bulletin) => {
        const bulletinYear = new Date(bulletin.date).getFullYear().toString();
        return bulletinYear === year;
      });
      setFilteredBulletins(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  return (
    <ThemeProvider theme={createTheme()}>
      <div style={{ backgroundColor: '#f0f4f8', paddingBottom: '20px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
            Rapports des Enquêtes Agricoles
          </Typography>
          <Divider style={{ margin: '20px 0' }} />
          <Typography variant="body1" align="left" gutterBottom>
           Cette section présent des rapports des Enquêtes Nationales Agricoles (ENAB) du Burundi. Ces enquêtes, menées régulièrement par l'Institut National de la Statistique du Burundi(INSBU), constituent une source d'information essentielle pour comprendre l'évolution du secteur agricole burundais. Elles offrent un aperçu détaillé des pratiques agricoles, des rendements des cultures, de l'élevage, et des défis auxquels sont confrontés les agriculteurs à travers le pays.
          </Typography>
          <FormControl fullWidth margin="normal" style={{ marginLeft: '0px', width: '300px',marginBottom:'20px' }}>
            <InputLabel id="year-select-label"> Sélectionnez une année de publication </InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label=" Sélectionnez une année de publication"
              variant="outlined"
            >
              <MenuItem value="Tous">Tous</MenuItem>
              {[...new Set(bulletinsData.map((bulletin) => new Date(bulletin.date).getFullYear()))]
                .sort()
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredBulletins.slice(0, visibleCount).map((bulletin, index) => (
              <Grid item xs={12} sm={6} md={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <CardMedia
                      component="img"
                      sx={{ width: 91, height: 140, m: 2, cursor: 'pointer' }}
                      image={bulletin.image}
                      alt={bulletin.title}
                      
                      onClick={() => window.open(bulletin.link, '_blank')} 
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: '#388E3C' }}>
                        <a
                          href={bulletin.link}
                          style={{ textDecoration: 'none', color: 'inherit' }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                        {<DownloadIcon />}  {bulletin.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {bulletin.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(bulletin.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredBulletins.length && (
            <Button
              onClick={handleShowMore}
              style={{ marginTop: '20px', backgroundColor: '#388E3C', color: 'white' }}
            >
              Plus de rapports
            </Button>
          )}
        </Container>
        <br />
      <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default EnqueteAgricole;